<template>
    <tr style="height: 120px;">
        <th>{{ label }}</th>
        <td class="md:w-2/5 md:max-w-xs">
            <span v-if="inputToggled">
                <text-input
                    v-model="value"
                    :type="type"
                    :name="name"
                    :tabindex="1"
                    :autofocus="true"
                    required
                />
            </span>
            <span v-else>{{ value }}</span>
        </td>
        <td class="text-right">
            <div v-if="inputToggled" class="flex flex-col-reverse md:flex-row md:justify-end">
                <button
                    type="button"
                    class="btn btn-md is-ghost mr-md"
                    tabindex="3"
                    @click="cancel"
                >
                    {{ lang('Avbryt','Cancel') }}
                </button>
                <button
                    type="button"
                    class="btn btn-md is-primary my-md md:my-0"
                    :class="{ 'is-loading': loading }"
                    :disabled="loading"
                    tabindex="2"
                    @click="updateValue"
                >
                    {{ lang('Spara','Save') }}
                </button>
            </div>
            <button
                v-else
                type="button"
                class="btn btn-md is-ghost mb-xl md:mb-0"
                @click="toggleInput"
            >
                {{ lang('Redigera','Edit') }}
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            initialValue: {
                type: String,
                required: false,
                default: null,
            },
            type: {
                type: String,
                default: 'text',
            },
        },

        data() {
            return {
                inputToggled: false,
                value: this.initialValue,
                savedValue: this.initialValue,
                loading: false,
            };
        },

        methods: {
            toggleInput() {
                this.inputToggled = ! this.inputToggled;
            },

            cancel() {
                this.value = this.savedValue;
                this.toggleInput();
            },

            async updateValue() {
                clear_flash_errors();
                this.loading = true;

                try {
                    const response = await this.sendUpdateRequest();
                    this.handleResponseData(response.data);
                    this.inputToggled = false;
                } catch (error) {
                    let errorMessage = error.response.data.message;
                    if (error.response.data.errors) {
                        errorMessage = Object.values(error.response.data.errors).flat()[0];
                    }

                    flash_error(errorMessage);
                }

                this.loading = false;
            },

            sendUpdateRequest() {
                return axios.patch(route('front.my-pages.api.profile.update'), {
                    key: this.name,
                    value: this.value,
                });
            },

            handleResponseData(responseData) {
                this.value = this.savedValue = responseData.value;

                if (responseData.redirect) {
                    window.location.href = responseData.redirect;
                } else {
                    flash_success();
                }
            },
        },
    };
</script>
